// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/2025_Heresy_Act1_Press_Kit_Dreadnaught_COMPRESSED_02.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
  /*background-image: radial-gradient(circle,#C02885,#3393AB);*/
  background-image: radial-gradient(circle,#206952e5,#91dac969), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: cover;
}

.data_container {
  display: flex;
  justify-content: center;
  color: #fff;
}

.flex_container {
  display: flex;
}

.Key {
  display: flex;
  color:white;
  justify-content: center;
  position: sticky;
  top: 0;
  background-color: #858585f5;
}

.Key p {
  margin-left: 2rem;
  margin-right: 2rem;
  width: 200px;
  text-align:center;
}

.App h1, .about {
  text-align: center;
  color: #fff;
}

.container {
  padding:0 50px 0;
}

#header {
  display: flex;
  justify-content: space-between;
}

.page_title {
  font-size: 3rem;
  text-align: center;
  color: #fff;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.completed img {
  height: 25px;
  vertical-align: bottom;
}

.needToComplete p {
  background-color: #8C1612;
  color: #fff;
  border-radius: 15px;
  padding:10px;
}

.challenge h2 {
  font-weight: normal;
}

.card {
  padding: 10px;
    border-radius: 25px;
    margin-top: 20px;
    background-color: rgba(0, 0, 0, 0.137);
    border: 2px solid #1c2a1f;
}

.menu ul {
  text-align: center;
  padding: 0;
}

.menu li {
  list-style-type: none;
  padding: 5px;
}

.menu a {
  color: #fff;
  font-size: 2rem;
}

.nightfall_info {
  text-align: center;
  color:#fff;
}

.nightfall_info h2 {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.nightfallTitle {
  font-size: 1.75rem;
}

.text-center {
  text-align: center;
}


.exotic {
  height: 15px;
  width: 15px;
  background-color: rgb(255, 217, 0);
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.pinnacle {
  height: 15px;
  width: 15px;
  background-color: rgb(214, 238, 0);
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.powerful-1 {
  height: 15px;
  width: 15px;
  background-color: rgb(14, 167, 0);
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.powerful-2 {
  height: 15px;
  width: 15px;
  background-color: rgb(0, 40, 172);
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

.powerful-3 {
  height: 15px;
  width: 15px;
  background-color: rgb(95, 0, 114);
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}

#andrew, #ian, #joe {
  color: #fff;
}

.destiny_image {
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  max-width: 200px;
}

.data_button {
  display: block;
margin-left: auto;
margin-right: auto;
padding: 10px;
border-radius: 15px;
margin-top: 20px;
background-color: rgba(0, 0, 0, 0.137);
border: 2px solid #1c2a1f;
color: #fff;
font-size: 1rem;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.w-500 {
  width: 500px;
}


/*sidebar*/
/* Position and sizing of burger button */
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 15px;
}

/* Color/shape of burger icon bars */
.bm-burger-bars {
  background: #fff;
}

/* Color/shape of burger icon bars on hover*/
.bm-burger-bars-hover {
  background: #fff;
}

/* Position and sizing of clickable cross button */
.bm-cross-button {
  height: 24px;
  width: 24px;
}

/* Color/shape of close button cross */
.bm-cross {
  background: #bdc3c7;
}

/*
Sidebar wrapper styles
*/
.bm-menu-wrap {
  position: fixed;
  height: 100%;
}

/* General sidebar styles */
.bm-menu {
  background: #0e1626;
  padding: 2.5em 1.5em 0;
  font-size: 1.15em;
}

/* Morph shape necessary with bubble or elastic */
.bm-morph-shape {
  fill: #0e1626;
}

/* Wrapper for item list */
.bm-item-list {
  color: #b8b7ad;
  padding: 0.8em;
}

/* Individual item */
.bm-item {
  display: inline-block;
}

/* Styling of overlay */
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}

a.menu-item {
  color: #fff;
  padding-top: 1rem;
}

.tenpx_gap {
  gap: 10px;
}

.font-bold {
  font-weight: bold;
}

.gold {
  color: gold;
}


@media screen and (max-width: 1000px) {
  .data_container {
    display: block;
  }
  .Key {
    display: block;
  }
  .Key p {
    width: auto;
  }
  .destiny_image {
    max-width: 50%;
  }
}

@media screen and (min-width: 501px) {
  .menu {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,sGAAqI;EACrI,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,MAAM;EACN,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;IACX,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB,iBAAiB;AACjB,kBAAkB;AAClB,aAAa;AACb,mBAAmB;AACnB,gBAAgB;AAChB,sCAAsC;AACtC,yBAAyB;AACzB,WAAW;AACX,eAAe;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;;AAGA,UAAU;AACV,yCAAyC;AACzC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA;;CAEC;AACD;EACE,eAAe;EACf,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["html {\n  scroll-behavior: smooth;\n  /*background-image: radial-gradient(circle,#C02885,#3393AB);*/\n  background-image: radial-gradient(circle,#206952e5,#91dac969), url('images/2025_Heresy_Act1_Press_Kit_Dreadnaught_COMPRESSED_02.jpg');\n  background-repeat: no-repeat;\n  background-position-x: center;\n  background-size: cover;\n}\n\n.data_container {\n  display: flex;\n  justify-content: center;\n  color: #fff;\n}\n\n.flex_container {\n  display: flex;\n}\n\n.Key {\n  display: flex;\n  color:white;\n  justify-content: center;\n  position: sticky;\n  top: 0;\n  background-color: #858585f5;\n}\n\n.Key p {\n  margin-left: 2rem;\n  margin-right: 2rem;\n  width: 200px;\n  text-align:center;\n}\n\n.App h1, .about {\n  text-align: center;\n  color: #fff;\n}\n\n.container {\n  padding:0 50px 0;\n}\n\n#header {\n  display: flex;\n  justify-content: space-between;\n}\n\n.page_title {\n  font-size: 3rem;\n  text-align: center;\n  color: #fff;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.completed img {\n  height: 25px;\n  vertical-align: bottom;\n}\n\n.needToComplete p {\n  background-color: #8C1612;\n  color: #fff;\n  border-radius: 15px;\n  padding:10px;\n}\n\n.challenge h2 {\n  font-weight: normal;\n}\n\n.card {\n  padding: 10px;\n    border-radius: 25px;\n    margin-top: 20px;\n    background-color: rgba(0, 0, 0, 0.137);\n    border: 2px solid #1c2a1f;\n}\n\n.menu ul {\n  text-align: center;\n  padding: 0;\n}\n\n.menu li {\n  list-style-type: none;\n  padding: 5px;\n}\n\n.menu a {\n  color: #fff;\n  font-size: 2rem;\n}\n\n.nightfall_info {\n  text-align: center;\n  color:#fff;\n}\n\n.nightfall_info h2 {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.nightfallTitle {\n  font-size: 1.75rem;\n}\n\n.text-center {\n  text-align: center;\n}\n\n\n.exotic {\n  height: 15px;\n  width: 15px;\n  background-color: rgb(255, 217, 0);\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.pinnacle {\n  height: 15px;\n  width: 15px;\n  background-color: rgb(214, 238, 0);\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.powerful-1 {\n  height: 15px;\n  width: 15px;\n  background-color: rgb(14, 167, 0);\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.powerful-2 {\n  height: 15px;\n  width: 15px;\n  background-color: rgb(0, 40, 172);\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.powerful-3 {\n  height: 15px;\n  width: 15px;\n  background-color: rgb(95, 0, 114);\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n#andrew, #ian, #joe {\n  color: #fff;\n}\n\n.destiny_image {\n  height: auto;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 10px;\n  max-width: 200px;\n}\n\n.data_button {\n  display: block;\nmargin-left: auto;\nmargin-right: auto;\npadding: 10px;\nborder-radius: 15px;\nmargin-top: 20px;\nbackground-color: rgba(0, 0, 0, 0.137);\nborder: 2px solid #1c2a1f;\ncolor: #fff;\nfont-size: 1rem;\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.w-500 {\n  width: 500px;\n}\n\n\n/*sidebar*/\n/* Position and sizing of burger button */\n.bm-burger-button {\n  position: fixed;\n  width: 36px;\n  height: 30px;\n  left: 36px;\n  top: 15px;\n}\n\n/* Color/shape of burger icon bars */\n.bm-burger-bars {\n  background: #fff;\n}\n\n/* Color/shape of burger icon bars on hover*/\n.bm-burger-bars-hover {\n  background: #fff;\n}\n\n/* Position and sizing of clickable cross button */\n.bm-cross-button {\n  height: 24px;\n  width: 24px;\n}\n\n/* Color/shape of close button cross */\n.bm-cross {\n  background: #bdc3c7;\n}\n\n/*\nSidebar wrapper styles\n*/\n.bm-menu-wrap {\n  position: fixed;\n  height: 100%;\n}\n\n/* General sidebar styles */\n.bm-menu {\n  background: #0e1626;\n  padding: 2.5em 1.5em 0;\n  font-size: 1.15em;\n}\n\n/* Morph shape necessary with bubble or elastic */\n.bm-morph-shape {\n  fill: #0e1626;\n}\n\n/* Wrapper for item list */\n.bm-item-list {\n  color: #b8b7ad;\n  padding: 0.8em;\n}\n\n/* Individual item */\n.bm-item {\n  display: inline-block;\n}\n\n/* Styling of overlay */\n.bm-overlay {\n  background: rgba(0, 0, 0, 0.3);\n}\n\na.menu-item {\n  color: #fff;\n  padding-top: 1rem;\n}\n\n.tenpx_gap {\n  gap: 10px;\n}\n\n.font-bold {\n  font-weight: bold;\n}\n\n.gold {\n  color: gold;\n}\n\n\n@media screen and (max-width: 1000px) {\n  .data_container {\n    display: block;\n  }\n  .Key {\n    display: block;\n  }\n  .Key p {\n    width: auto;\n  }\n  .destiny_image {\n    max-width: 50%;\n  }\n}\n\n@media screen and (min-width: 501px) {\n  .menu {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
